<template>
  <div class="reg-select">
    <h3 style="text-align: left" v-if="state.response.transactionStatus == 'Approved'">Your payment was
      successful!</h3>
    <h3 style="text-align: left" v-else-if="state.response.transactionStatus == 'No Payment Required'">Your order
      was successful!</h3>
    <h3 style="text-align: left" v-else>Looks like there was an error with your order</h3>


    <div
        v-if="state.response.transactionStatus == 'Approved' || state.response.transactionStatus == 'No Payment Required'">
      <h5 class="header">Thank you for Registering for New Frontiers In Cosmetic Medicine 2026</h5> <br>
      <p>Thank you for registering for the <strong>New Frontiers in Cosmetic Medicine Symposium</strong> taking place on
        November 21-22, 2026 at the Hilton Hotel in Hasbrouck Heights, NJ. Get ready for a fabulous learning experience!
      </p>
      <p>Check your provided email for your order receipt and additional meeting information.</p>
    </div>
    <div v-else>
      <p>Your card was declined for the reason below:</p>
      <p>{{ state.response.details }}</p>

      <!--<button class="btn btn-default" @click="resetResponse">Go Back</button>-->
    </div>
    <iframe src="https://www.cosmeticfrontiers.com/api/2026/meeting/conversion.php" frameborder="0"
            style="display: none"></iframe>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Confirmation',
  mounted() {
    // This is our google event conversion snippet
    gtag('event', 'conversion', {
      'send_to': 'AW-17513251490/dkcJCLCdr5QbEKKF_J5B',
      'value': this.state.registrantData.total,
      'email': this.state.registrantData.attendeeEmail,
      'currency': 'USD',
      'transaction_id': ''
    })
  },
  computed: {
    ...mapGetters({
      state: 'getState',

    }),
  },
  methods: {
    resetResponse: function () {
      this.state.response = {};
    },
  },
}
</script>

<style scoped>

</style>
